var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShouldBeIrrigated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SHOULD_BE_IRRIGATED",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #SHOULD_BE_IRRIGATED .cls-1 {\n        fill: #f5f5f5;\n      }\n\n      #SHOULD_BE_IRRIGATED .cls-2 {\n        fill: #33bc12;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_113",
    "data-name": "Pfad 113",
    className: "cls-1",
    d: "M22.3,18.4a6.3,6.3,0,1,1-12.6,0C9.7,14.9,16,5.9,16,5.9S22.3,14.9,22.3,18.4Zm-3.5-2.1a1.6,1.6,0,1,0,1.6,1.6A1.721,1.721,0,0,0,18.8,16.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_114",
    "data-name": "Pfad 114",
    className: "cls-2",
    d: "M16,2A14,14,0,1,1,2,16,14.041,14.041,0,0,1,16,2m0-2A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShouldBeIrrigated);
export default __webpack_public_path__ + "static/media/should-be-irrigated.b7e2ec5beb7558171228004ef4137ef2.svg";
export { ForwardRef as ReactComponent };